export const MOBILE_BOTTOM_BAR_COPY = {
  board: "Board",
  velocity: "Velocity",
  createTask: "Create task",
  more: "More",
} as const;

export const MOBILE_BOARD_COPY = {
  moreMenu: "Board menu",
  intakes: "Intakes",
  listeners: "Pull request feedback",
  noIntakes: "No intakes yet",
  needsRepair: "Needs repair",
  searchPlaceholder: "Search tasks",
  closeSearch: "Close search",
  switchLine: "Switch line",
  lines: "Lines",
  loadingMore: "Loading more",
  loadMoreError: "SuperPlane could not load more tasks.",
  loadMoreRetry: "Try again",
} as const;

export const MOBILE_SETTINGS_COPY = {
  title: "Settings",
  backToWorkspace: "Back to workspace",
  findPlaceholder: "Find settings",
  noResults: "No matching settings.",
} as const;

export const MOBILE_TASK_COPY = {
  back: "Back to board",
  loading: "Loading task…",
  notFound: "This task could not be opened.",
  notFoundHelp: "It may have been deleted or you may not have access to it.",
  description: "Description",
  noDescription: "No description.",
  activity: "Activity",
  noActivity: "No activity yet. Start the task to run the line.",
  pullRequests: "Pull requests",
  files: "Files",
  showLog: "Show log",
  hideLog: "Hide log",
  noRefinementSession: "This task has no refinement session, so replies are not available.",
} as const;
